import QuantityProduct from './QuantityProduct'

class PortraitPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 1
}

export default PortraitPhotoProduct
